import { Check } from "lucide-react";
import { ONBOARDING_GOALS } from "@/data/onboarding";
import { StepShell } from "../OnboardingPrimitives";

export default function StepGoal({ state, update }) {
  return (
    <StepShell
      stepId="goal"
      eyebrow="Step 01 · Your goal"
      title={<>What brings you to the <span className="italic text-aurora">Studio</span>?</>}
    >
      <div className="space-y-3 sm:space-y-4">
        {ONBOARDING_GOALS.map((g) => {
          const active = state.goal === g.id;
          return (
            <button
              key={g.id}
              type="button"
              data-testid={`onboarding-goal-${g.id}`}
              onClick={() => update("goal", g.id)}
              className={`group w-full text-left p-5 sm:p-6 rounded-md transition border ${
                active
                  ? "border-transparent aurora-border bg-[#FAFAFA]"
                  : "border-neutral-200 hover:border-[#D4AF37]/60 bg-white"
              }`}
            >
              <div className="flex items-start gap-4">
                <span className={`flex-none w-5 h-5 rounded-full mt-1 flex items-center justify-center transition ${active ? "bg-aurora" : "border border-neutral-300"}`}>
                  {active && <Check size={12} className="text-[#1a1206]" strokeWidth={3} />}
                </span>
                <div className="flex-1">
                  <div className="font-display text-base sm:text-lg font-medium text-neutral-900">{g.label}</div>
                  <div className="text-sm text-neutral-500 mt-1">{g.desc}</div>
                </div>
              </div>
            </button>
          );
        })}
      </div>
    </StepShell>
  );
}
